import SportsIcon from "@material-ui/icons/Sports";
import BusinessIcon from "@material-ui/icons/Business";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import LabelIcon from "@material-ui/icons/Label";

import { AppResource } from "../../../types/resource.types";
import EntertainmentsProfile from "../../Profiles/EntertainmentsProfile";
import EntertainmentDashboard from "./Dashboard";
import Chat from "../../Chat";
import AccountSettings from "../../AccountSettings";
import {
  ServicesAdventureCreate,
  ServicesAdventureEdit,
  ServicesAdventureList,
} from "../../EntertainmentsVendors/Services/Adventure";
import {
  ServicesEntertainmentCreate,
  ServicesEntertainmentEdit,
  ServicesEntertainmentList,
} from "../../EntertainmentsVendors/Services/Entertainment";
import { EntertainmentsReviewsList } from "../../EntertainmentsVendors/Reviews";
import { RequestsList } from "../../EntertainmentsVendors/Requests";
import EntertainmentRequestsList from "../../EntertainmentsVendors/EntertainmentRequests/List";
import EntertainmentFullNotificationList from "../../EntertainmentsVendors/EntertainmentNotifications/EntertainmentFullNotificationList";

export const EntertainmentAccount = {
  resources: [
    <Resource
      name={AppResource.adventureServices}
      list={ServicesAdventureList}
      edit={ServicesAdventureEdit}
      create={ServicesAdventureCreate}
      icon={BusinessIcon}
      options={{
        label: "Adventure Services",
      }}
    />,
    <Resource
      name={AppResource.adventureRequests}
      list={RequestsList}
      icon={LabelIcon}
      options={{
        label: "Adventure Requests",
      }}
    />,
    <Resource
      name={AppResource.entertainmentServices}
      list={ServicesEntertainmentList}
      edit={ServicesEntertainmentEdit}
      create={ServicesEntertainmentCreate}
      icon={BusinessIcon}
      options={{
        label: "Entertainment Tickets",
      }}
    />,

    <Resource
      name={AppResource.entertainmentRequests}
      list={EntertainmentRequestsList}
      icon={LabelIcon}
      options={{
        label: "Entertainment Requests",
      }}
    />,

    <Resource
      name={AppResource.entertainmentReviews}
      list={EntertainmentsReviewsList}
      icon={SportsIcon}
      options={{
        label: "Reviews",
      }}
    />,
    <Resource name={AppResource.clients} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.profile}`} component={EntertainmentsProfile} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.notifications}`} component={EntertainmentFullNotificationList} />,
  ],
  dashboard: EntertainmentDashboard,
};
